import { ArrowBackIosFilledOutlined } from "@mui-symbols-material/w300"
import React from "react"

interface ArrowIconProps {
  size?: string
  color?: string
  rotation?: Rotation.up | Rotation.down | Rotation.left | Rotation.right
  extraStyles?: React.CSSProperties
}

enum Rotation {
  up = 90,
  down = -90,
  left = 180,
  right = 0,
}

const ArrowIcon: React.FC<ArrowIconProps> = ({
  rotation = Rotation.down,
  size = "1.5rem",
  color = "rgba(0, 0, 0, 0.54)",
  extraStyles,
}) => {
  return (
    <ArrowBackIosFilledOutlined
      sx={{
        fontSize: size,
        color: color,
        transform: `rotate(${rotation}deg)`,
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        flexShrink: 0,
        transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        fill: "currentColor",
        pointerEvents: "none",
        ...extraStyles,
      }}
    />
  )
}

export default ArrowIcon
